export default __webpack_public_path__ + "static/42-2707acdf57784416fa684082be79cd63.png";